import { QueryClient } from '@tanstack/react-query';
import { LIST_ITEMS_COUNT } from '@/constants/lists.constants';
import { bannedTailNumbersQuery } from '@/queries/banned-tail-numbers';
import { PaginationSearchParams } from '@/api/types';

export const bannedTailNumbersLoader = (queryClient: QueryClient) => () => {
  const params: PaginationSearchParams = {
    itemsPerPage: LIST_ITEMS_COUNT,
    pageIndex: 0,
  };
  return queryClient.ensureQueryData(bannedTailNumbersQuery.list(params));
};

export const bannedTailNumbersByIdLoader = (queryClient: QueryClient) => (bannedTailNumberId: string) => {
  return queryClient.fetchQuery({
    ...bannedTailNumbersQuery.item(bannedTailNumberId),
  });
};
